import { cva } from 'class-variance-authority';

export const textAreaVariants = cva(
  [
    'flex-1',
    'relative',
    'p-0',
    'min-w-[56px]',
    'min-h-[16px]',
    'border-0',
    'outline-none',
    'bg-transparent',
    'leading-sys-line-height-24',
    'tracking-font-sys-letter-spacing-0',
    '[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none',
  ],
  {
    variants: {
      isDisabled: {
        true: [
          'cursor-not-allowed',
          'text-color-comp-text-field-on-container-disabled',
          'placeholder-color-comp-text-field-on-container-disabled',
        ],
        false: [
          'cursor-text',
          'text-color-comp-text-field-on-container-selected',
          'placeholder-color-comp-text-field-on-container-enabled',
        ],
      },
      textAreaSize: {
        small: [
          'leading-sys-line-height-16',
          'min-h-sizing-comp-text-field-small-multi-line',
        ],
        medium: [
          'leading-sys-line-height-24',
          'min-h-sizing-comp-text-field-medium-multi-line',
        ],
      },
    },
    defaultVariants: {
      isDisabled: false,
    },
  },
);
